export default function UnStickNoteIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 12.5H2C1.725 12.5 1.5 12.275 1.5 12V2C1.5 1.725 1.725 1.5 2 1.5H12C12.275 1.5 12.5 1.725 12.5 2V7.5H9.75C8.50625 7.5 7.5 8.50625 7.5 9.75V12.5ZM11.8781 9L9 11.8781V9.75C9 9.33438 9.33438 9 9.75 9H11.8781ZM0 12C0 13.1031 0.896875 14 2 14H8.17188C8.70312 14 9.2125 13.7906 9.5875 13.4156L13.4156 9.58438C13.7906 9.20938 14 8.7 14 8.16875V2C14 0.896875 13.1031 0 12 0H2C0.896875 0 0 0.896875 0 2V12Z" fill="#674759" />
    </svg>
  );
}
